export const selectIsLoggedIn = state => state.auth.isLoggedIn;
